import { FileCard } from "#features/conversations/components/files/FileCard.tsx";
import type { ConversationMessage } from "#types/types.ts";
import { Flex } from "@hopper-ui/components";

interface Props {
    message: ConversationMessage;
}

export const FileMessage = ({ message: { files } }: Props) => {
    if (!files) {
        return null;
    }

    return (
        <Flex direction="column" gap="inline-sm" alignItems="end" UNSAFE_marginBottom="-1rem">
            {files.map(file => <FileCard key={file.id} file={file} />)}
        </Flex>
    );
};
